import React from "react";
import ResumeLineDividerIconSVG from "assets/svg/resume-line-divider-icon";
import { sortMilestones, formatDate } from "utils/utils";
import { groupArraysWithType } from "../../resume";
import { LogoBlue } from "constants/images";
import { useTranslation } from "react-i18next";
import { QRResume_TEMP_5 } from "../../qr-code/qr-resume";
import { A4_SIZE } from "../../resume";
import { removePostalCode } from "utils/utils";
import { useResume } from "redux/modules/resume/hooks";
import { truncateBioForTemplate } from "utils/bio-limit";
import { TEMPLATE_NAME_5 } from "constants/options";
export default function TemplateFiveFullPageTwo(props) {
  // ===================== props ============================
  const {
    details = {},
    personal = {},
    maxHeight="290mm",
    milestones = {},
    show_qr_milestone,
    show_qr_reels,
    milestone_position,
    profile={},
    fullPreview = true
  } = props;
    const { t } = useTranslation();
    const [mergeMilestone, setMergeMilestone] = React.useState([]);
    const {bio} = useResume();
    const truncatedBio = truncateBioForTemplate(bio, TEMPLATE_NAME_5);
  React.useEffect(() => {
      const arraysWithType = [
            { array: sortMilestones(milestones?.featured) || [], type: 'featured' },
            { array: sortMilestones(milestones?.current) || [], type: 'current' },
            { array: sortMilestones(milestones?.past) || [], type: 'past' },
          ];
        let groupAll = groupArraysWithType(arraysWithType, 10, 10);
        if(groupAll.length){
          setMergeMilestone(groupAll[0]);
        }else{
          setMergeMilestone([])
        }
        
    }, [milestones]);

  return (
      <div className="w-full relative box-border" style={A4_SIZE}>
        {/* ouside padding */}
        <div className={`min-w-[816px] bg-white template-four-two-padding-full h-full`}
        style={
          // !fullPreview
          //   ? { minHeight: maxHeight }
          //   : { height: maxHeight }
          {height: "305mm"}
        }
        >
          {/* inner padding */}
          <div className={`w-full h-full relative flex flex-col justify-between ${fullPreview && 'px-12'}`}>
            {/* body start */}
            <div
              className="w-full flex flex-col gap-y-5 overflow-hidden">
              {/* header */}
              <div className="w-full flex flex-row justify-between items-center">
                <div className="flex flex-col w-full justify-center items-center">
                  <p className="text-4.5xl font-bold leading-8.5 tracking-resumeName mb-2 text-resumeTempFourTextPrimary"
                    // style={{ color: tertiaryColor }}
                    >
                    {personal.hasOwnProperty("name") && personal.name && (
                      <>{personal.name}</>
                    )}
                  </p>
                  {personal.hasOwnProperty("occupations") &&
                      <p className="text-center">
                        {
                          personal.occupations.length > 0 && (
                          <li className="w-full flex space-x-1.5">
                            <p className="text-6xs text-resumeTempFourTextPrimary">
                              {(personal.occupations || []).map(
                                (val, index) => {
                                  const count = personal.occupations.length;
                                  if (index >= count - 1 && count !== 1) {
                                    return " and " + val;
                                  } else {
                                    if (index >= count - 2) {
                                      return val;
                                    } else {
                                      return val + ", ";
                                    }
                                  }
                                }
                              )}
                            </p>
                          </li>
                        )
                        }
                      </p>
                      }
                  <div className="flex flex-row gap-x-2 items-center justify-center">
                    {personal.hasOwnProperty("gender") && personal.gender && (
                      <p className="text-6xs text-resumeTempFourTextPrimary">{personal.gender}</p>
                    )}
                    {personal.hasOwnProperty("gender") &&
                      personal.gender &&
                      personal.hasOwnProperty("pronoun") &&
                      personal.pronoun && (
                        <span className="opacity-30">&#8226;</span>
                      )}
                    {personal.hasOwnProperty("pronoun") && personal.pronoun && (
                      <p className="text-6xs text-resumeTempFourTextPrimary">{personal.pronoun}</p>
                    )}
                    {personal.hasOwnProperty("address") && personal.address && (
                      <>
                        <span className="opacity-30 text-6xs text-resumeTempFourTextPrimary">&#8226;</span>
                        <p className="text-6xs">{personal.address}</p>
                      </>
                    )}
                  </div>
                </div>
              </div>
              {/* end header */}
              {/* Divider */}
              <div className="w-full">
                <ResumeLineDividerIconSVG full={true} />
              </div>
              {/*  */}
              <div className="w-full">
                <div className="w-full flex flex-row gap-x-6">
                  {/* Personal Info */}
                  <div className="w-full">
                    <p className="text-resumeTempFourTextPrimary text-6xs font-bold tracking-resumeFour">
                      Professional Information
                    </p>
                    <div className="w-full">
                      {details?.hasOwnProperty("bio") && details?.bio && (
                        <div className="w-full flex mt-1.5">
                          <p className="text-resumeTempFourTextPrimary text-6xs font-medium tracking-resumeFour w-32">
                            Bio
                          </p>
                          <div className="w-full">
                            <div className={`text-4xs text-resumeTempFourTextPrimary tracking-resume leading-4 self-stretch line-clamp-4`}>
                             <div dangerouslySetInnerHTML={{ __html: truncatedBio || '' }}></div>
                            </div>
                          </div>
                        </div>
                      )}
                      {details?.hasOwnProperty("education") && details?.education && (
                        <div className="w-full flex mt-1.5">
                          <p className="text-resumeTempFourTextPrimary text-6xs font-medium tracking-resumeFour w-32">
                            Education
                          </p>
                          <div className="w-full">
                            <p className="text-4xs text-resumeTempFourTextPrimary tracking-resume leading-4 self-stretch line-clamp-2">
                              {details.education}
                            </p>
                          </div>
                        </div>
                      )}
                      {details?.hasOwnProperty("training") && details?.training && (
                        <div className="w-full flex mt-1.5">
                          <p className="text-resumeTempFourTextPrimary text-6xs font-medium tracking-resumeFour w-32">
                            Training
                          </p>
                          <div className="w-full">
                            <p className="text-4xs text-resumeTempFourTextPrimary tracking-resume leading-4 self-stretch line-clamp-3">
                              {details.training}
                            </p>
                          </div>
                        </div>
                      )}
                      {details?.hasOwnProperty("experience") && details?.experience && (
                        <div className="w-full flex mt-1.5">
                          <p className="text-resumeTempFourTextPrimary text-6xs font-medium tracking-resumeFour w-32">
                            Experience
                          </p>
                          <div className="w-full">
                            <p className="text-4xs text-resumeTempFourTextPrimary tracking-resume leading-4 self-stretch line-clamp-3">
                              {details.experience}
                            </p>
                          </div>
                        </div>
                      )}
                      {details?.hasOwnProperty("awards") && details?.awards && (
                        <div className="w-full flex mt-1.5">
                          <p className="text-resumeTempFourTextPrimary text-6xs font-medium tracking-resumeFour w-32">
                            Awards
                          </p>
                          <div className="w-full">
                            <p className="text-4xs text-resumeTempFourTextPrimary tracking-resume leading-4 self-stretch line-clamp-3">
                              {details.awards}
                            </p>
                          </div>
                        </div>
                      )}
                      {details?.hasOwnProperty("representation") && details?.representation && (
                        <div className="w-full flex mt-1.5">
                          <p className="text-resumeTempFourTextPrimary text-6xs font-medium tracking-resumeFour w-32">
                            Representation
                          </p>
                          <div className="w-full">
                            <p className="text-4xs text-resumeTempFourTextPrimary tracking-resume leading-4 self-stretch line-clamp-3">
                              {details.representation}
                            </p>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                  {/* divider */}
                  {/* More Information and Contact */}
                  <div className="w-[50%] space-y-2">
                    <div>
                      <p className="text-resumeTempFourTextPrimary text-6xs font-bold tracking-resumeFour">
                        Contact
                      </p>
                        {/* Phone  */}
                          {details?.hasOwnProperty("phone_number") &&
                            details?.phone_number && (
                              <p className="text-4xs text-resumeTempFourTextPrimary">
                                {details.phone_number}
                              </p>
                            )}
                          {/* email  */}
                          {details?.hasOwnProperty("email") && details?.email && (
                            <p className="text-4xs">
                                {details?.email}
                              </p>
                          )}
                    </div>
                      <div>
                        <p className="text-resumeTempFourTextPrimary text-6xs font-bold tracking-resumeFour">
                          More Information
                        </p>
                        <div className="w-full grid">
                            {/* Hair Color */}
                            {details?.hasOwnProperty("hair_color") &&
                              details.hair_color && (
                                <div className="w-full flex flex-row">
                                  <div className="w-21.5">
                                    <p className="text-6xs text-resumeTempFourTextPrimary font-medium">
                                      Hair Color
                                    </p>
                                  </div>
                                  <p className="text-4xs text-resumeTempFourTextPrimary">
                                    {details.hair_color}
                                  </p>
                                </div>
                              )}
                            {/* Eye Color */}
                            {details?.hasOwnProperty("eye_color") &&
                              details.eye_color && (
                                <div className="w-full flex flex-row">
                                  <div className="w-21.5">
                                    <p className="text-6xs text-resumeTempFourTextPrimary font-medium">
                                      Eye Color
                                    </p>
                                  </div>
                                  <p className="text-4xs text-resumeTempFourTextPrimary">
                                    {details.eye_color}
                                  </p>
                                </div>
                              )}

                            {/* Height */}
                            {details?.hasOwnProperty("height") && details.height && (
                              <div className="w-full flex flex-row ">
                                <div className="w-21.5">
                                  <p className="text-6xs text-resumeTempFourTextPrimary font-medium">
                                    Height
                                  </p>
                                </div>
                                <p className="text-4xs text-resumeTempFourTextPrimary ">
                                  {details.height}cm
                                </p>
                              </div>
                            )} 
                            {/* Email */}
                            {details?.hasOwnProperty("email") && details.email && (
                              <div className="w-full flex flex-row ">
                                <div className="w-21.5">
                                  <p className="text-6xs text-resumeTempFourTextPrimary font-medium">
                                    Email
                                  </p>
                                </div>
                                <p className="text-4xs text-resumeTempFourTextPrimary ">
                                  {details.email}
                                </p>
                              </div>
                            )} 
                            {/* Birth Location */}
                            {details?.hasOwnProperty("birth_location") && details?.birth_location && (
                              <div className="w-full flex flex-row ">
                                <div className="w-21.5">
                                  <p className="text-6xs text-resumeTempFourTextPrimary font-medium">
                                    Birth Location
                                  </p>
                                </div>
                                <p className="text-4xs text-resumeTempFourTextPrimary ">
                                  {details?.birth_location}
                                </p>
                              </div>
                            )} 
                            {/* children */}
                            {/* {details?.hasOwnProperty("children") && details?.children > 0 && (
                              <div className="w-full flex flex-row ">
                                <div className="w-21.5">
                                  <p className="text-6xs text-resumeTempFourTextPrimary font-medium">
                                    Children
                                  </p>
                                </div>
                                <p className="text-4xs text-resumeTempFourTextPrimary ">
                                  {details?.children}
                                </p>
                              </div>
                            )}  */}
                        </div>
                        </div>
                  </div>
                </div>
              </div>
              {/* Divider */}
              <div className="w-full">
                <ResumeLineDividerIconSVG full={true} />
              </div>
              {/*  Milestone List */}
              <div className="w-full">
                  <p className="text-resumeTempFourTextPrimary text-6xs font-bold tracking-resumeFour mb-2">
                    My Milestones
                  </p>
                  <div className="w-full grid grid-cols-2 gap-4">
                    {
                      mergeMilestone.slice(0,10).map((item,index)=>{
                        // let display = item?.positions ? (fullPreview ? item?.positions : item?.positions.filter(item => milestone_position.some(hide => hide?.positions.includes(item.position_id)))) : [];
                        let display = (item?.positions ? item?.positions
                          .filter(pos =>
                            !milestone_position.some(hide =>
                              hide?.[item?.id]?.includes(pos.position_id)
                            )
                          ): []);
                        return (<div key={index}>
                          <p className="text-4xs font-bold">{item.title}</p>
                          <p className="text-4xs font-medium line-clamp-2">{formatDate(item,profile?.dateFormat,t)} 
                            { item.date_note && (
                                    <span className="pl-1 text-4xs">
                                      &#8226;
                                      <span className="pl-1 ">{item.date_note}</span>
                                    </span> 
                                )}
                          </p>
                          <div className="w-full my-0.5 text-7xs line-clamp-2">
                              {item?.positions &&
                                  display.slice(0, 2).map((p) => {
                                    const _pos = [p.position.name?.trim()];
                                    if (p.description)
                                      _pos.push(removePostalCode(p.description).trim());
                                    return _pos.join(" - ");
                                  })
                                  .join(", ")
                                  .trim()
                                } 
                            </div>
                          <div
                                className="text-4xs text-resumeTempFourTextPrimary tracking-resume leading-3.2 line-clamp-3"
                                dangerouslySetInnerHTML={{
                                  __html: item?.description === 'null' || !item?.description ? "" :  item?.description,
                                }}
                              />
                        </div>)
                      })
                    }
                  </div>
              </div>
              {/* end */}
            </div>
            {/* footer */}
            {/* <QRResume_TEMP_5 {...{show_qr_milestone,show_qr_reels}} />   */}
            
            <div className="w-full flex items-end">
              <div className="w-full">
              <QRResume_TEMP_5 {...{show_qr_milestone,show_qr_reels}} preview={!fullPreview}/>  
                <div className={`w-full flex justify-center gap-2 items-center ${fullPreview ? 'py-3' : 'pt-3'}`}>
                  <img src={LogoBlue} alt="logo" className="w-6 h-6"/> 
                  <p className="text-xs text-resumeTempFourTextPrimary leading-4 opacity-90">
                    Made with Milestone Page
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  );
}
